export default {
      id: "info-grey-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#info-grey",
      toString: function () {
        return this.url;
      }
    }